import { produce } from 'immer';
import { ACCEPT_TERMS_SUCCESS_TERMS_ACCEPTED } from 'app/store/__generated__/events';
import { WEBSOCKET_AUTH } from 'app/store/websocketStatus';
import { DELETE_USER } from 'app/store/admin/types.js';
import {
    SIGN_IN_KEYCLOAK,
    SIGN_OUT,
    LIST_USER_DETAILS,
    GET_ACCEPT_TERMS,
    KEYCLOAK_TOKEN_REFRESHED,
    KEYCLOAK_TOKEN_REFRESH
} from './types.js';

export const USERS_INITIAL_STATE = {
    currentUserId: null,
    byUserId: {},
    maximumNumberOfAccounts: null,
    restrictOnMaximumNumberOfAccounts: null,
    groups: [],
    isLoading: false
};

export const USER_AUTH_INITIAL_STATE = {
    sessionId: null,
    termsAccepted: null,
    keycloakReady: false,
    wsReady: false
};

function ensureUserExists(draft, userId) {
    if (!draft.byUserId.hasOwnProperty(userId)) {
        draft.byUserId[userId] = {};
    }
}

function storeUser(draft, user) {
    const name = user.username;
    ensureUserExists(draft, name);
    Object.assign(draft.byUserId[name], user);
}

export const userAuthReducer = produce((draft, action) => {
    switch (action.type) {
        case KEYCLOAK_TOKEN_REFRESHED:
        case SIGN_IN_KEYCLOAK.SUCCEEDED:
            draft.keycloakReady = true;
            return;
        case WEBSOCKET_AUTH.SUCCEEDED:
            draft.wsReady = true;
            return;
        case GET_ACCEPT_TERMS.SUCCEEDED:
            draft.termsAccepted = action.payload.termsAccepted;
            return;
        case ACCEPT_TERMS_SUCCESS_TERMS_ACCEPTED:
            draft.termsAccepted = true;
            return;
        case SIGN_IN_KEYCLOAK.FAILED:
            return USER_AUTH_INITIAL_STATE;
        case KEYCLOAK_TOKEN_REFRESH.FAILED:
        case SIGN_OUT:
            return USER_AUTH_INITIAL_STATE;
        default:
    }
}, USER_AUTH_INITIAL_STATE);

export const usersReducer = produce((draft, action) => {
    switch (action.type) {
        case SIGN_IN_KEYCLOAK.SUCCEEDED: {
            draft.currentUserId = action.payload.username;
            storeUser(draft, action.payload);
            return;
        }
        case WEBSOCKET_AUTH.SUCCEEDED:
            draft.currentUserId = action.payload.user.username;
            storeUser(draft, action.payload.user);
            return;
        case LIST_USER_DETAILS.STARTED:
            draft.isLoading = true;
            return;
        case LIST_USER_DETAILS.ENDED:
            draft.isLoading = false;
            return;
        case LIST_USER_DETAILS.SUCCEEDED:
            for (const user of action.payload.users) {
                storeUser(draft, user);
            }
            draft.maximumNumberOfAccounts = action.payload.maximumNumberOfAccounts;
            draft.restrictOnMaximumNumberOfAccounts =
                action.payload.restrictOnMaximumNumberOfAccounts;
            draft.groups = action.payload.groups;
            return;
        case LIST_USER_DETAILS.FAILED:
            draft.groups = [];
            draft.byUserId = { [draft.currentUserId]: draft.byUserId[draft.currentUserId] };
            return;
        case DELETE_USER.SUCCEEDED:
            delete draft.byUserId[action.payload.username];
            return;
        case SIGN_IN_KEYCLOAK.FAILED:
        case SIGN_OUT:
            return USERS_INITIAL_STATE;
        default:
    }
}, USERS_INITIAL_STATE);
